import { defineMessages } from "@/i18n";
import en from "./en";

export const settingsVoiceVocabularyMessages = defineMessages(
  "settings-voice-vocabulary",
  en,
);
